import '@/styles/normalize.css';
import '@/styles/index.less';
import '@/styles/element-variables.scss';
import '@/styles/chartist.min.css';

import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import Chartist from 'vue-chartist';
import VueLocalstorage from 'vue-localstorage';
import moment from 'moment';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ko';
import axios from 'axios';
import qs from 'qs';
import Meta from 'vue-meta';

import App from './App.vue';
import router from './router';
import store from './store';

if (!process.env.NODE_ENV) {
  process.env.NODE_ENV = 'development';
}

Vue.use(Chartist);
Vue.use(ElementUI, { locale });
Vue.use(VueLocalstorage);
Vue.use(Meta);

moment.locale('ko');

Vue.config.productionTip = false;

Vue.prototype.s3ProdImgPath = '//img.sta1.com';
Vue.prototype.s3TestImgPath = '//s3.ap-northeast-2.amazonaws.com/sta1-upload-local';

const token = Vue.localStorage.get('token');

if (token) {
  if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_TEST_SERVER === 'Y') {
    axios.defaults.headers.common.Authorization = `Basic ${btoa(process.env.VUE_APP_TEST_SERVER)}`;
  }
  axios.defaults.headers.common['mk-sess'] = token;
}

axios.defaults.baseURL = process.env.VUE_APP_AXIOS_BASEURL;

axios.interceptors.request.use((config) => {
  if (!(config.data instanceof FormData)) {
    config.data = qs.stringify(config.data);
  }
  return config;
});

Vue.prototype.$http = axios;

const r = router(store, Vue.prototype.$http);
sync(store, r);

new Vue({
  router: r,
  store,
  render: h => h(App),
}).$mount('#app');
